import { APP_INITIALIZER, NgModule } from '@angular/core';
import { AuthService } from './services/auth.service';
import {
  BrowserModule,
  provideClientHydration,
} from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './shared/header/header.component';
import { NotificacoesContratoComponent } from './shared/notificacoes-contrato/notificacoes-contrato.component';
import { ContratoInfoCardComponent } from './shared/contrato-info-card/contrato-info-card.component';
import { ParcelasContratoComponent } from './shared/parcelas-contrato/parcelas-contrato.component';
import { MenuLateralComponent } from './shared/menu-lateral/menu-lateral.component';
import { LoginComponent } from './pages/login/login.component';
import { SignupComponent } from './pages/signup/signup.component';
import { GrupoComponent } from './pages/grupos/grupo/grupo.component';
import { SubgrupoComponent } from './pages/grupos/subgrupo/subgrupo.component';
import { MarcaComponent } from './pages/marca/marca.component';
import { FooterComponent } from './shared/footer/footer.component';
import { HomeComponent } from './pages/home/home.component';
import { ConfiguracaoUnidadeDeMedidaComponent } from './pages/configuracao-unidade-de-medida/configuracao-unidade-de-medida.component';
import { ConfiguracaoGeralComponent } from './pages/configuracao-geral/configuracao-geral.component';
import { ClienteComponent } from './pages/cliente/add-cliente/cliente.component';
import { FornecedorComponent } from './pages/fornecedor/fornecedor-add/fornecedor.component';
import { ConfiguracaoDaEmpresaComponent } from './pages/configuracao/configuracao-da-empresa/configuracao-da-empresa.component';
import { UsuarioComponent } from './pages/usuario/usuario.component';
import { GrupoDePrivilegioComponent } from './pages/grupo-de-privilegio/grupo-de-privilegio.component';
import { ListaDeClientesComponent } from './pages/cliente/lista-de-clientes/lista-de-clientes.component';
import { ListaDeFornecedoresComponent } from './pages/fornecedor/lista-de-fornecedores/lista-de-fornecedores.component';

import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputTextModule } from 'primeng/inputtext';
import { KeyFilterModule } from 'primeng/keyfilter';
import { ToastModule } from 'primeng/toast';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { CalendarModule } from 'primeng/calendar';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { TooltipModule } from 'primeng/tooltip';
import { ToggleButtonModule } from 'primeng/togglebutton';
import { FileUploadModule } from 'primeng/fileupload';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TagModule } from 'primeng/tag'
import { SidebarModule } from 'primeng/sidebar';
import { CarouselModule } from 'primeng/carousel';

import {
  HTTP_INTERCEPTORS, provideHttpClient, withFetch,
  HttpClient,
  withInterceptorsFromDi,
  // HttpClientModule,
} from '@angular/common/http';
import { AuthInterceptor } from './shared/auth.interceptor';
import { HttpErrorInterceptor } from './shared/http-error.interceptor';
import { CheckboxModule } from 'primeng/checkbox';
import { ContasComponent } from './pages/gerenciar-contas/conta/contas/contas.component';
import { NovaDespesaComponent } from './pages/nova-despesa/nova-despesa.component';
import { NovaReceitaComponent } from './pages/nova-receita/nova-receita.component';
import { NovaTransferenciaComponent } from './pages/nova-transferencia/nova-transferencia.component';
import { MovimentacaoComponent } from './pages/movimentacao/movimentacao.component';
import { CotacaoComponent } from './pages/cotacao/cotacao.component';
import { CotacaoEditComponent } from './pages/cotacao/cotacao-edit/cotacao-edit.component';
import { ConfiguracaoEstadoComponent } from './pages/configuracao/configuracao-estado/configuracao-estado.component';
import { AuthGuard } from './guards/auth.guard';
import { ApiService } from './services/api.service';
import { MessageService } from 'primeng/api';
import { ConfiguracaoCidadeComponent } from './pages/configuracao/configuracao-cidade/configuracao-cidade.component';
import { ConfiguracaoEmpresasComponent } from './pages/configuracao/configuracao-empresas/configuracao-empresas.component';
import { MasterEmpresasComponent } from './pages/master/master-empresas/master-empresas.component';
import { MasterUsuariosComponent } from './pages/master/master-usuarios/master-usuarios.component';
import { MasterPlanosComponent } from './pages/master/master-planos/master-planos.component';
import { MasterDashboardRecebimentosChartComponent } from './pages/master/master-planos/master-dashboard-recebimentos-chart/master-dashboard-recebimentos-chart.component';
import { MasterDashboardUsoChartComponent } from './pages/master/master-planos/master-dashboard-uso-chart/master-dashboard-uso-chart.component';
import { MasterCuponsComponent } from './pages/master/master-cupons/master-cupons.component';
import { MasterEmpresaDetalheComponent } from './pages/master/master-empresa-detalhe/master-empresa-detalhe.component';
import { ConfiguracaoEstadoEditComponent } from './pages/configuracao/configuracao-estado/configuracao-estado-edit/configuracao-estado-edit.component';

import { AtividadeEconomicaComponent } from './pages/configuracao/configuracao-atividade-economica/configuracao-atividade-economica.component';
import { AtividadeEconomicaEditComponent } from './pages/configuracao/configuracao-atividade-economica/configuracao-atividade-economica-edit/configuracao-atividade-economica-edit.component';

import { TimbradoComponent } from './pages/configuracao/timbrado/timbrado.component';
import { ImpressorasComponent } from './pages/configuracao/impressoras/impressoras.component';
import { ListadeClientesViewComponent } from './pages/cliente/lista-de-clientes/lista-de-clientes-view/lista-de-clientes-view.component';
import { TabViewModule } from 'primeng/tabview';
import { CardModule } from 'primeng/card';
import { ClientesCardComponent } from './pages/cliente/lista-de-clientes/lista-de-clientes-view/componentes/clientes-card/clientes-card.component';
import { ClientesTableComponent } from './pages/cliente/lista-de-clientes/lista-de-clientes-view/componentes/clientes-table/clientes-table.component';
import { DialogModule } from 'primeng/dialog';
import { MovimentacaoTableComponent } from './pages/cliente/lista-de-clientes/lista-de-clientes-view/componentes/movimentacao-table/movimentacao-table.component';
import { AvatarModule } from 'primeng/avatar';
import { AtividadeEconomicaAddComponent } from './pages/configuracao/componentes/atividade-economica-add/atividade-economica-add.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { AutoFocusModule } from 'primeng/autofocus';
import { ListadeFornecedoresViewComponent } from './pages/fornecedor/lista-de-fornecedores/lista-de-fornecedores-view/lista-de-fornecedores-view.component';
import { ListadePessoasViewComponent } from './shared/components/lista-de-pessoas-view/lista-de-pessoas-view.component';
import { PessoasTableComponent } from './shared/components/lista-de-pessoas-view/componentes/pessoas-table/pessoas-table.component';
import { MovimentacaoPessoaTableComponent } from './shared/components/lista-de-pessoas-view/componentes/pessoas-movimentacao-table/movimentacao-table.component';
import { PessoasCardComponent } from './shared/components/lista-de-pessoas-view/componentes/pessoas-card/pessoas-card.component';
import { ItemsTableComponent } from './shared/components/lista-de-pessoas-view/componentes/pessoas-items-table/items-table.component';
import { UnidadeDeMedidaComponent } from './pages/unidade-de-medida/unidade-de-medida.component';
import { SelectButtonModule } from 'primeng/selectbutton';
import { FornecedorCompraComponent } from './pages/fornecedor/fornecedor-compra/fornecedor-compra.component';
import { EntitySelectorComponent } from './shared/components/entity-selector/entity-selector.component';
import { PessoaAdicionarDialogComponent } from './shared/components/pessoa-adicionar-dialog/pessoa-adicionar-dialog.component';
import { MarcaAdicionarDialogComponent } from './shared/components/marca-adicionar-dialog/marca-adicionar-dialog.component';
import { ImpressoraAdicionarDialogComponent } from './shared/components/impressora-adicionar-dialog/impressora-adicionar-dialog.component';
import { GrupoAdicionarDialogComponent } from './shared/components/grupo-adicionar-dialog/grupo-adicionar-dialog.component';
import { ItemCriarRapidoComponent } from './shared/components/item-criar-rapido/item-criar-rapido.component';
import { SubgrupoAdicionarDialogComponent } from './shared/components/subgrupo-adicionar-dialog/subgrupo-adicionar-dialog.component';
import { UnidadeAdicionarDialogComponent } from './shared/components/unidade-adicionar-dialog/unidade-adicionar-dialog.component';
import { NotasListComponent } from './pages/notas/notas-list.component';
import { SelecionarItemComponent } from './pages/fornecedor/fornecedor-compra/components/fornecedor/produto-selecionar/produto-selecionar.component';
import { ItensTableComponent } from './shared/components/lista-de-pessoas-view/componentes/item/itens-table/itens-table.component';
import { ItemFormCardComponent } from './shared/components/lista-de-pessoas-view/componentes/item/item-form-card/item-form-card.component';
import { FloatLabelModule } from 'primeng/floatlabel';
import { AdicionarItemComponent } from './pages/fornecedor/fornecedor-compra/components/fornecedor/produto-adicionar/produto-adicionar.component';
import { TriStateCheckboxModule } from 'primeng/tristatecheckbox';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputSwitchModule } from 'primeng/inputswitch';
import { GrupoEditComponent } from './pages/grupos/grupo/grupo-edit/grupo-edit.component';
import { SubGrupoEditComponent } from './pages/grupos/subgrupo/sub-grupo-edit/sub-grupo-edit.component';
import { EditMarcaComponent } from './pages/marca/marca-edit/edit-marca.component';
import { ModalComponent } from './shared/modal/modal.component';

import { NgxMaskDirective, provideNgxMask } from 'ngx-mask';
import { InputMaskModule } from 'primeng/inputmask';
import { NovaContaComponent } from './pages/gerenciar-contas/conta/nova-conta/nova-conta.component';
import { ClienteEditComponent } from './pages/cliente/add-cliente/cliente-edit/cliente-edit.component';
import { ClientesComponent } from './pages/clientes/clientes.component';
import { FornecedoresComponent } from './pages/fornecedores/fornecedores.component';
import { FornecedorEditComponent } from './pages/fornecedor/fornecedor-add/fornecedor-edit/fornecedor-edit.component';
import { GrupoDePrivilegioEditComponent } from './pages/grupo-de-privilegio/grupo-de-privilegio-edit/grupo-de-privilegio-edit.component';
import { NovaContaEditComponent } from './pages/gerenciar-contas/conta/nova-conta/nova-conta-edit/nova-conta-edit.component';
import { NovaDespesaEditComponent } from './pages/nova-despesa/nova-despesa-edit/nova-despesa-edit.component';
// NovaReceitaEditComponent deprecado (ajuste-tela-novo-ingresso) - edicao inline no componente principal
import { NovaTransferenciaEditComponent } from './pages/nova-transferencia/nova-transferencia-edit/nova-transferencia-edit.component';

import { ProdutosComponent } from './pages/produtos/produtos/produtos.component';
import { ListaDeProdutosComponent } from './pages/produtos/lista-de-produtos/lista-de-produtos.component';
import { ProdutosEditComponent } from './pages/produtos/produtos/produtos-edit/produtos-edit.component';
import { EtiquetaItemComponent } from './pages/produtos/etiqueta-item/etiqueta-item.component';
import { ExtratoEstoqueComponent } from './pages/produtos/extrato-estoque/extrato-estoque.component';
import { AjusteEstoqueComponent } from './pages/produtos/ajuste-estoque/ajuste-estoque.component';
import { VendasComponent } from './pages/vendas/vendas.component';
import { ImportarPedidoDialogComponent } from './pages/vendas/componentes/importar-pedido-dialog/importar-pedido-dialog.component';
import { SkeletonModule } from 'primeng/skeleton';
import { RadioButtonModule } from 'primeng/radiobutton';
import { registerLocaleData } from '@angular/common';
import localeEsPy from '@angular/common/locales/es-PY';
import localePt from '@angular/common/locales/pt';
import localeEn from '@angular/common/locales/en';
import localeEsAr from '@angular/common/locales/es-AR';
import { GuaraniFormatPipe } from './pipes/guarani-format.pipe';
import { FormatPhonePipe } from './pipes/format-phone.pipe';
import { MoedaSimboloPipe } from './shared/pipes/moeda-simbolo.pipe';
import { RelatoriosComponent } from './pages/relatorios/relatorios/relatorios.component';
import { AccordionModule } from 'primeng/accordion';
import { RelatorioVendasComponent } from './pages/relatorios/relatorio-vendas/relatorio-vendas.component';
import { RelatorioItensVendidosComponent } from './pages/relatorios/relatorio-itens-vendidos/relatorio-itens-vendidos.component';
import { RelatorioProdutosComponent } from './pages/relatorios/relatorio-produtos/relatorio-produtos.component';
import { RelatorioContasPagasComponent } from './pages/relatorios/relatorio-contas-pagas/relatorio-contas-pagas.component';
import { RelatorioContasRecebidasComponent } from './pages/relatorios/relatorio-contas-recebidas/relatorio-contas-recebidas.component';
import { RelatorioContasAPagarComponent } from './pages/relatorios/relatorio-contas-a-pagar/relatorio-contas-a-pagar.component';
import { RelatorioDreComponent } from './pages/relatorios/relatorio-dre/relatorio-dre.component';
import { RelatorioContasAReceberComponent } from './pages/relatorios/relatorio-contas-a-receber/relatorio-contas-a-receber.component';
import { ButtonModule } from 'primeng/button';
import { BadgeModule } from 'primeng/badge';
import { PasswordModule } from 'primeng/password';
import { ForgotPasswordComponent } from './pages/forgot-password/forgot-password.component';
import { InputOtpModule } from 'primeng/inputotp';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { DashboardHeaderComponent } from './pages/dashboard/dashboard-header/dashboard-header.component';
import { DashboardAvisosComponent } from './pages/dashboard/dashboard-avisos/dashboard-avisos.component';
import { DashboardPlanoComponent } from './pages/dashboard/dashboard-plano/dashboard-plano.component';
import { DashboardPrimeirosPassosComponent } from './pages/dashboard/dashboard-primeiros-passos/dashboard-primeiros-passos.component';
import { DashboardFaturaEletronicaComponent } from './pages/dashboard/dashboard-fatura-eletronica/dashboard-fatura-eletronica.component';
import { DashboardContasComponent } from './pages/dashboard/dashboard-contas/dashboard-contas.component';
import { DashboardGraficoLinhaComponent } from './pages/dashboard/dashboard-grafico-linha/dashboard-grafico-linha.component';
import { DashboardGraficoPizzaComponent } from './pages/dashboard/dashboard-grafico-pizza/dashboard-grafico-pizza.component';
import { DashboardMinhasContasComponent } from './pages/dashboard/dashboard-minhas-contas/dashboard-minhas-contas.component';
import { DashboardEstoqueComponent } from './pages/dashboard/dashboard-estoque/dashboard-estoque.component';
import { DashboardContadorNotificacoesComponent } from './pages/dashboard/dashboard-contador-notificacoes/dashboard-contador-notificacoes.component';
import { NotificacoesContadorComponent } from './pages/notificacoes-contador/notificacoes-contador.component';
import { ChartModule } from 'primeng/chart';
import { DividerModule } from 'primeng/divider';
import { KnobModule } from 'primeng/knob';
import { ProgressBarModule } from 'primeng/progressbar';
import { DataViewModule } from 'primeng/dataview';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';

import { LanguageService } from './shared/language.service';
import { FaturaComponent } from './pages/notas/fatura/fatura.component';
import { FaturaViewComponent } from './shared/components/fatura-view/fatura-view.component';
import { ZeroMaskDirective } from './directives/zero-mask.directive';
import { DigitsOnlyDirective } from './directives/digits-only.directive';
import { MonetaryMaskDirective } from './directives/monetary-mask.directive';
import { DragScrollDirective } from './directives/drag-scroll.directive';
import { InputNumberModule } from 'primeng/inputnumber';
import { LoadingDialogComponent } from './shared/components/modal/loading-dialog/loading-dialog.component';
import { SelectGrupoComponent } from './shared/components/select-grupo/select-grupo.component';
import { SelectSubgrupoComponent } from './shared/components/select-subgrupo/select-subgrupo.component';
import { SelectMarcaComponent } from './shared/components/select-marca/select-marca.component';
import { SelectImpressoraComponent } from './shared/components/select-impressora/select-impressora.component';
import { SelectUnidadeMedidaComponent } from './shared/components/select-unidade-medida/select-unidade-medida.component';
import { ConfiguracaoMineShopComponent } from './pages/configuracao/configuracao-mine-shop/configuracao-mine-shop.component';
import { ColumnSelectorComponent } from './shared/components/column-selector/column-selector.component';
import { FormaPagamentoDialogComponent } from './shared/components/forma-pagamento-dialog/forma-pagamento-dialog.component';
import { DadosDeRecebimentoComponent } from './pages/configuracao/dados-de-recebimento/dados-de-recebimento.component';
import { FormaPagamentoCardsComponent } from './shared/components/forma-pagamento-cards/forma-pagamento-cards.component';
import { RucBuscaComponent } from './shared/components/ruc-busca/ruc-busca.component';
import { RucConfirmacaoDialogComponent } from './shared/components/ruc-confirmacao-dialog/ruc-confirmacao-dialog.component';
import { PeriodoFiltroComponent } from './shared/components/periodo-filtro/periodo-filtro.component';
import { PhoneInputComponent } from './shared/components/phone-input/phone-input.component';
import { InputQuantidadeComponent } from './shared/components/input-quantidade/input-quantidade.component';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { MenuModule } from 'primeng/menu';
import { DragDropModule } from '@angular/cdk/drag-drop';

// Planos
import { PlanosComponent } from './pages/planos/planos.component';
import { PlanoCardComponent } from './pages/planos/plano-card/plano-card.component';

// Pedidos
import { PedidosComponent } from './pages/pedidos/pedidos.component';
import { CriarPedidoComponent } from './pages/criar-pedido/criar-pedido.component';
import { VarianteModificadorDialogComponent } from './shared/components/variante-modificador-dialog/variante-modificador-dialog.component';
import { PedidoCardComponent } from './pages/pedidos/componentes/pedido-card/pedido-card.component';
import { PedidoDetalheDialogComponent } from './pages/pedidos/componentes/pedido-detalhe-dialog/pedido-detalhe-dialog.component';
import { PedidoEstadosDialogComponent } from './pages/pedidos/componentes/pedido-estados-dialog/pedido-estados-dialog.component';
import { PedidoAdicionarItemDialogComponent } from './pages/pedidos/componentes/pedido-adicionar-item-dialog/pedido-adicionar-item-dialog.component';
import { NotificacaoPedidoDialogComponent } from './pages/pedidos/componentes/notificacao-pedido-dialog/notificacao-pedido-dialog.component';
import { ImprimirPedidoDialogComponent } from './pages/pedidos/componentes/imprimir-pedido-dialog/imprimir-pedido-dialog.component';

// Cotacao Dialog Global
import { CotacaoDialogComponent } from './shared/components/cotacao-dialog/cotacao-dialog.component';

// Sem Permissao
import { SemPermissaoComponent } from './pages/sem-permissao/sem-permissao.component';

// Avisos (gerenciamento)
import { AvisosComponent } from './pages/avisos/avisos.component';
// Indicacoes (Programa de Indicacoes)
import { IndicacoesComponent } from './pages/indicacoes/indicacoes.component';
// Contador Parceiro
import { AreaContadorComponent } from './pages/contador/area-contador/area-contador.component';
import { SolicitarContadorComponent } from './pages/contador/solicitar-contador/solicitar-contador.component';
import { SolicitarContadorPanelComponent } from './pages/contador/solicitar-contador-panel/solicitar-contador-panel.component';
import { OperarClienteComponent } from './pages/contador/operar-cliente/operar-cliente.component';
import { OperarConfigEmpresaComponent } from './pages/contador/operar-cliente/componentes/config-empresa/config-empresa.component';
import { OperarDespesaAcessoriaComponent } from './pages/contador/operar-cliente/componentes/despesa-acessoria/despesa-acessoria.component';
import { OperarItensComponent } from './pages/contador/operar-cliente/componentes/operar-itens/operar-itens.component';
import { OperarCategoriasComponent } from './pages/contador/operar-cliente/componentes/operar-categorias/operar-categorias.component';
import { OperarSubcategoriasComponent } from './pages/contador/operar-cliente/componentes/operar-subcategorias/operar-subcategorias.component';
import { OperarMarcasComponent } from './pages/contador/operar-cliente/componentes/operar-marcas/operar-marcas.component';
import { OperarUnidadesComponent } from './pages/contador/operar-cliente/componentes/operar-unidades/operar-unidades.component';
import { OperarVendaComponent } from './pages/contador/operar-cliente/componentes/operar-venda/operar-venda.component';
import { OperarVendaItemSelectorComponent } from './pages/contador/operar-cliente/componentes/operar-venda/operar-venda-item-selector/operar-venda-item-selector.component';
import { OperarVendaItemBuscaComponent } from './pages/contador/operar-cliente/componentes/operar-venda/operar-venda-item-busca/operar-venda-item-busca.component';
import { OperarVendaLinhaComponent } from './pages/contador/operar-cliente/componentes/operar-venda/operar-venda-linha/operar-venda-linha.component';
import { OperarVendaCompletarClienteComponent } from './pages/contador/operar-cliente/componentes/operar-venda/operar-venda-completar-cliente/operar-venda-completar-cliente.component';
import { OperarClientesComponent } from './pages/contador/operar-cliente/componentes/operar-clientes/operar-clientes.component';
import { OperarFornecedoresComponent } from './pages/contador/operar-cliente/componentes/operar-fornecedores/operar-fornecedores.component';
import { ContadorContextoInterceptor } from './shared/contador-contexto.interceptor';
import { MasterContextoInterceptor } from './shared/master-contexto.interceptor';
import { AprovacaoContadorComponent } from './pages/contador/aprovacao-contador/aprovacao-contador.component';
import { AprovacaoSolicitacoesComponent } from './pages/contador/aprovacao-contador/componentes/aprovacao-solicitacoes/aprovacao-solicitacoes.component';
import { RepasseComissoesComponent } from './pages/contador/comissoes/componentes/repasse-comissoes/repasse-comissoes.component';
import { HistoricoPagamentosComponent } from './pages/contador/comissoes/componentes/historico-pagamentos/historico-pagamentos.component';
import { ComissoesComponent } from './pages/contador/comissoes/comissoes.component';

// Cardapio Digital
import { CardapioDigitalComponent } from './pages/cardapio-digital/cardapio-digital.component';
import { CardapioProdutoCardComponent } from './pages/cardapio-digital/componentes/cardapio-produto-card/cardapio-produto-card.component';
import { CardapioModificadorModalComponent } from './pages/cardapio-digital/componentes/cardapio-modificador-modal/cardapio-modificador-modal.component';
import { CardapioCarrinhoFooterComponent } from './pages/cardapio-digital/componentes/cardapio-carrinho-footer/cardapio-carrinho-footer.component';
import { CardapioSidebarComponent } from './pages/cardapio-digital/componentes/cardapio-sidebar/cardapio-sidebar.component';
import { CardapioCarrinhoComponent } from './pages/cardapio-digital/componentes/cardapio-carrinho/cardapio-carrinho.component';
import { CardapioCheckoutComponent } from './pages/cardapio-digital/componentes/cardapio-checkout/cardapio-checkout.component';
import { CardapioProdutoDetalheComponent } from './pages/cardapio-digital/componentes/cardapio-produto-detalhe/cardapio-produto-detalhe.component';
import { CardapioTrackingComponent } from './pages/cardapio-digital/componentes/cardapio-tracking/cardapio-tracking.component';
import { CardapioHistoricoComponent } from './pages/cardapio-digital/componentes/cardapio-historico/cardapio-historico.component';
import { CardapioLojaFechadaDialogComponent } from './pages/cardapio-digital/componentes/cardapio-loja-fechada-dialog/cardapio-loja-fechada-dialog.component';
import { CardapioAvisoDialogComponent } from './pages/cardapio-digital/componentes/cardapio-aviso-dialog/cardapio-aviso-dialog.component';

// Cardapio Minishop (Gestao do Cardapio)
import { CardapioMinishopComponent } from './pages/configuracao/configuracao-mine-shop/componentes/cardapio-minishop/cardapio-minishop.component';
import { CardapioMinishopHeaderComponent } from './pages/configuracao/configuracao-mine-shop/componentes/cardapio-minishop-header/cardapio-minishop-header.component';
import { CardapioMinishopDestaqueComponent } from './pages/configuracao/configuracao-mine-shop/componentes/cardapio-minishop-destaque/cardapio-minishop-destaque.component';
import { CardapioMinishopCategoriaListComponent } from './pages/configuracao/configuracao-mine-shop/componentes/cardapio-minishop-categoria-list/cardapio-minishop-categoria-list.component';
import { CardapioMinishopProdutoItemComponent } from './pages/configuracao/configuracao-mine-shop/componentes/cardapio-minishop-produto-item/cardapio-minishop-produto-item.component';
import { CardapioMinishopProdutoEditComponent } from './pages/configuracao/configuracao-mine-shop/componentes/cardapio-minishop-produto-edit/cardapio-minishop-produto-edit.component';
import { CardapioMinishopFooterComponent } from './pages/configuracao/configuracao-mine-shop/componentes/cardapio-minishop-footer/cardapio-minishop-footer.component';
import { VarianteSecaoComponent } from './pages/configuracao/configuracao-mine-shop/componentes/cardapio-minishop-produto-edit/componentes/variante-secao/variante-secao.component';
import { ModificadorSecaoComponent } from './pages/configuracao/configuracao-mine-shop/componentes/cardapio-minishop-produto-edit/componentes/modificador-secao/modificador-secao.component';
import { ModificadorGestaoModalComponent } from './pages/configuracao/configuracao-mine-shop/componentes/cardapio-minishop-produto-edit/componentes/modificador-gestao-modal/modificador-gestao-modal.component';

// Imagens secundarias do item (cadastro + visualizacao + detalhe PDV)
import { ItemImagensSecundariasComponent } from './shared/components/item-imagens-secundarias/item-imagens-secundarias.component';
import { ItemImagensCarrosselComponent } from './shared/components/item-imagens-carrossel/item-imagens-carrossel.component';
import { VendasProdutoDetalheComponent } from './pages/vendas/componentes/vendas-produto-detalhe/vendas-produto-detalhe.component';

registerLocaleData(localeEsPy, 'es-PY');
registerLocaleData(localePt, 'pt-BR');
registerLocaleData(localeEn, 'en-US');
registerLocaleData(localeEsAr, 'es-AR');

const ConfiguracaoComponets = [
  ConfiguracaoDaEmpresaComponent,
  ConfiguracaoEmpresasComponent,
  MasterEmpresasComponent,
  MasterUsuariosComponent,
  MasterPlanosComponent,
  MasterDashboardRecebimentosChartComponent,
  MasterDashboardUsoChartComponent,
  MasterCuponsComponent,
  MasterEmpresaDetalheComponent,
  ConfiguracaoEstadoComponent,
  ConfiguracaoEstadoEditComponent,
  ConfiguracaoCidadeComponent,

  AtividadeEconomicaComponent,
  AtividadeEconomicaEditComponent,
  TimbradoComponent,
  ImpressorasComponent,

  ListadeClientesViewComponent,
  AtividadeEconomicaAddComponent,
  UnidadeDeMedidaComponent,
];

const GruposComponets = [
  GrupoComponent,
  GrupoEditComponent,
  SubgrupoComponent,
  SubGrupoEditComponent,
];

const AuthComponents = [LoginComponent, SignupComponent];

const SharedComponents = [
  AppComponent,
  HeaderComponent,
  NotificacoesContratoComponent,
  ContratoInfoCardComponent,
  ParcelasContratoComponent,
  ModalComponent,
  MenuLateralComponent,
  FooterComponent,
  ListadePessoasViewComponent,
  PessoasTableComponent,
  MovimentacaoPessoaTableComponent,
  PessoasCardComponent,
  ItemsTableComponent,
  ItensTableComponent,
  ItemFormCardComponent,
  FaturaViewComponent,
  ColumnSelectorComponent,
  FormaPagamentoDialogComponent,
  DadosDeRecebimentoComponent,
  FormaPagamentoCardsComponent,
  RucBuscaComponent,
  RucConfirmacaoDialogComponent,
  EntitySelectorComponent,
  PeriodoFiltroComponent,
  PhoneInputComponent,
  InputQuantidadeComponent,
];
const UsuariosComponents = [
  UsuarioComponent,
  GrupoDePrivilegioComponent,
  GrupoDePrivilegioEditComponent,
];

const ClientesComponents = [
  ClienteComponent,
  ListaDeClientesComponent,
  ClientesCardComponent,
  ClientesTableComponent,
  MovimentacaoTableComponent,
  ClienteEditComponent,
  ClientesComponent,
];

const FornecedorComponents = [
  FornecedorComponent,
  ListaDeFornecedoresComponent,
  ListadeFornecedoresViewComponent,
  FornecedorCompraComponent,
  PessoaAdicionarDialogComponent,
  SelecionarItemComponent,
  FornecedorEditComponent,
  FornecedoresComponent,
];

const NotasComponent = [AdicionarItemComponent];

import { ContasPagarReceberComponent } from './pages/contas-pagar-receber/contas-pagar-receber.component';
import { ResumoTotaisComponent } from './pages/contas-pagar-receber/componentes/resumo-totais/resumo-totais.component';
import { ListaTitulosComponent } from './pages/contas-pagar-receber/componentes/lista-titulos/lista-titulos.component';
import { ListaDespesasComponent } from './pages/contas-pagar-receber/componentes/lista-despesas/lista-despesas.component';
import { ContasAReceberComponent } from './pages/contas-a-receber/contas-a-receber.component';
import { ContasAPagarComponent } from './pages/contas-a-pagar/contas-a-pagar.component';
import { TitulosPessoaComponent } from './pages/contas-a-receber/componentes/titulos-pessoa/titulos-pessoa.component';
import { RecebimentoDialogComponent } from './pages/contas-a-receber/componentes/recebimento-dialog/recebimento-dialog.component';

const GerenciarContasComponents = [
  NovaContaComponent,
  ContasComponent,
  NovaDespesaComponent,
  NovaReceitaComponent,
  NovaTransferenciaComponent,
  MovimentacaoComponent,
  CotacaoComponent,
  CotacaoEditComponent,
  NovaContaEditComponent,
  ContasPagarReceberComponent,
  ResumoTotaisComponent,
  ListaTitulosComponent,
  ListaDespesasComponent,
  ContasAReceberComponent,
  ContasAPagarComponent,
  TitulosPessoaComponent,
  RecebimentoDialogComponent,
];

const CardapioDigitalComponents = [
  CardapioDigitalComponent,
  CardapioProdutoCardComponent,
  CardapioProdutoDetalheComponent,
  CardapioModificadorModalComponent,
  CardapioCarrinhoFooterComponent,
  CardapioSidebarComponent,
  CardapioCarrinhoComponent,
  CardapioCheckoutComponent,
  CardapioTrackingComponent,
  CardapioHistoricoComponent,
  CardapioLojaFechadaDialogComponent,
  CardapioAvisoDialogComponent,
];

const CardapioMinishopComponents = [
  CardapioMinishopComponent,
  CardapioMinishopHeaderComponent,
  CardapioMinishopDestaqueComponent,
  CardapioMinishopCategoriaListComponent,
  CardapioMinishopProdutoItemComponent,
  CardapioMinishopProdutoEditComponent,
  CardapioMinishopFooterComponent,
  VarianteSecaoComponent,
  ModificadorSecaoComponent,
  ModificadorGestaoModalComponent,
];

const MarcaComponents = [MarcaComponent, EditMarcaComponent];

const HomeComponents = [HomeComponent];
const UnidadeDeMedidaComponents = [ConfiguracaoUnidadeDeMedidaComponent, ConfiguracaoGeralComponent];

const NotasList = [NotasListComponent];

// Loader custom que busca /assets/i18n/<lang>.json
//
// Cache-busting do i18n: os arquivos assets/i18n/*.json tem nome FIXO (o Angular
// nao gera hash neles), entao sem o parametro ?v= o navegador serve a versao
// antiga em cache apos um deploy e as chaves de traducao aparecem cruas.
//
// QUANDO ATUALIZAR I18N_CACHE_VERSION (formato AAAAMMDD):
//   - Em releases normais NAO e necessario: o nginx envia Cache-Control: no-cache
//     para esses arquivos (ver default.conf), entao o navegador revalida e ja
//     pega as traducoes novas a cada carregamento.
//   - Bump APENAS para forcar um reset geral de cache (ex.: caches antigos
//     teimosos, CDN/proxy intermediario, ou mudanca na estrategia de cache).
const I18N_CACHE_VERSION = '20260616';

export function createTranslateLoader(http: HttpClient): TranslateLoader {
  return {
    getTranslation: (lang: string) =>
      http.get<Record<string, string>>(`/assets/i18n/${lang}.json?v=${I18N_CACHE_VERSION}`)
  };
}

// Inicializa idioma antes do app subir (retorna Observable para APP_INITIALIZER aguardar)
export function initApp(langService: LanguageService) {
  return () => langService.init();
}



export function authInitFactory(auth: AuthService) {
  return () => auth.bootstrapAuth();  // <- espera terminar
}
@NgModule({
  declarations: [
    ImportarPedidoDialogComponent,
    ...AuthComponents,
    ...HomeComponents,
    ...SharedComponents,
    ...GruposComponets,
    ...MarcaComponents,
    ...UnidadeDeMedidaComponents,
    ...GerenciarContasComponents,
    ...UsuariosComponents,
    ...ClientesComponents,
    ...FornecedorComponents,
    ...ConfiguracaoComponets,
    ...CardapioDigitalComponents,
    ...CardapioMinishopComponents,
    ...NotasList,
    ...NotasComponent,
    NovaDespesaEditComponent,
    // NovaReceitaEditComponent deprecado (ajuste-tela-novo-ingresso)
    NovaTransferenciaEditComponent,

    ProdutosComponent,
    ListaDeProdutosComponent,
    ProdutosEditComponent,
    EtiquetaItemComponent,
    ExtratoEstoqueComponent,
    AjusteEstoqueComponent,
    VendasComponent,
    GuaraniFormatPipe,
    FormatPhonePipe,
    MoedaSimboloPipe,
    RelatoriosComponent,
    RelatorioVendasComponent,
    RelatorioItensVendidosComponent,
    RelatorioProdutosComponent,
    RelatorioContasPagasComponent,
    RelatorioContasRecebidasComponent,
    RelatorioContasAPagarComponent,
    RelatorioDreComponent,
    RelatorioContasAReceberComponent,
    ForgotPasswordComponent,
    DashboardComponent,
    DashboardHeaderComponent,
    DashboardAvisosComponent,
    DashboardPlanoComponent,
    DashboardPrimeirosPassosComponent,
    DashboardFaturaEletronicaComponent,
    DashboardContasComponent,
    DashboardGraficoLinhaComponent,
    DashboardGraficoPizzaComponent,
    DashboardMinhasContasComponent,
    DashboardEstoqueComponent,
    DashboardContadorNotificacoesComponent,
    NotificacoesContadorComponent,
    FaturaComponent,
    ZeroMaskDirective,
    DigitsOnlyDirective,
    MonetaryMaskDirective,
    DragScrollDirective,
    LoadingDialogComponent,
    SelectGrupoComponent,
    SelectSubgrupoComponent,
    SelectMarcaComponent,
    SelectImpressoraComponent,
    SelectUnidadeMedidaComponent,
    MarcaAdicionarDialogComponent,
    ImpressoraAdicionarDialogComponent,
    GrupoAdicionarDialogComponent,
    ItemCriarRapidoComponent,
    SubgrupoAdicionarDialogComponent,
    UnidadeAdicionarDialogComponent,
    ConfiguracaoMineShopComponent,
    PlanosComponent,
    PlanoCardComponent,
    PedidosComponent,
    CriarPedidoComponent,
    VarianteModificadorDialogComponent,
    PedidoCardComponent,
    PedidoDetalheDialogComponent,
    PedidoEstadosDialogComponent,
    PedidoAdicionarItemDialogComponent,
    NotificacaoPedidoDialogComponent,
    ImprimirPedidoDialogComponent,
    CotacaoDialogComponent,
    SemPermissaoComponent,
    AvisosComponent,
    IndicacoesComponent,
    AreaContadorComponent,
    SolicitarContadorComponent,
    SolicitarContadorPanelComponent,
    OperarClienteComponent,
    OperarConfigEmpresaComponent,
    OperarDespesaAcessoriaComponent,
    OperarItensComponent,
    OperarCategoriasComponent,
    OperarSubcategoriasComponent,
    OperarMarcasComponent,
    OperarUnidadesComponent,
    OperarVendaComponent,
    OperarVendaItemSelectorComponent,
    OperarVendaItemBuscaComponent,
    OperarVendaLinhaComponent,
    OperarVendaCompletarClienteComponent,
    OperarClientesComponent,
    OperarFornecedoresComponent,
    AprovacaoContadorComponent,
    AprovacaoSolicitacoesComponent,
    RepasseComissoesComponent,
    HistoricoPagamentosComponent,
    ComissoesComponent,
    // Imagens secundarias do item
    ItemImagensSecundariasComponent,
    ItemImagensCarrosselComponent,
    VendasProdutoDetalheComponent,
  ],
  imports: [
    ChartModule,
    RadioButtonModule,
    SkeletonModule,
    SelectButtonModule,
    ProgressSpinnerModule,
    ReactiveFormsModule,
    CheckboxModule,
    // HttpClientModule,
    FileUploadModule,
    ToggleButtonModule,
    TooltipModule,
    BrowserAnimationsModule,
    ConfirmDialogModule,
    CalendarModule,
    PaginatorModule,
    TableModule,
    ToastModule,
    InputTextModule,
    KeyFilterModule,
    InputIconModule,
    IconFieldModule,
    DropdownModule,
    MultiSelectModule,
    InputMaskModule,
    FormsModule,
    MessagesModule,
    MessageModule,
    BrowserModule,
    AppRoutingModule,
    TabViewModule,
    CardModule,
    DialogModule,
    AvatarModule,
    AutoCompleteModule,
    AutoFocusModule,
    FloatLabelModule,
    TriStateCheckboxModule,
    InputTextareaModule,
    InputSwitchModule,
    AccordionModule,
    ButtonModule,
    BadgeModule,
    PasswordModule,
    InputOtpModule,
    NgxMaskDirective,
    DividerModule,
    KnobModule,
    ProgressBarModule,
    DataViewModule,
    InputNumberModule,
    TagModule,
    SidebarModule,
    CarouselModule,
    OverlayPanelModule,
    MenuModule,
    DragDropModule,
    TranslateModule.forRoot({
        loader: {
            provide: TranslateLoader,
            useFactory: createTranslateLoader,
            deps: [HttpClient]
        },
    }),
],
  exports: [
    GuaraniFormatPipe,
    FormatPhonePipe,
    MoedaSimboloPipe
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initApp,
      deps: [LanguageService],
      multi: true
    },
    provideClientHydration(),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    AuthGuard,
    ApiService,
    MessageService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ContadorContextoInterceptor, multi: true },
    // Depois do contador: os dois escrevem o mesmo header, e o master nao sobrescreve o que ja
    // estiver posto (ver MasterContextoInterceptor).
    { provide: HTTP_INTERCEPTORS, useClass: MasterContextoInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: HttpErrorInterceptor, multi: true },
    { provide: APP_INITIALIZER, useFactory: authInitFactory, deps: [AuthService], multi: true },
    provideNgxMask(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
